import CheckboxList from './CheckboxList.jsx';
import { useEventTypesQuery } from '../lib/Queries';

const EventTypeCheckboxes = ({
    value,
    onChange,
    defaultAll,
    excludeClasses,
    id,
    renderLabel,
}) => {
    const { data } = useEventTypesQuery();
    const eventTypeOptions = (data || [])
        .map(type => {
            if (!excludeClasses || !type.is_class) {
                return {
                    label: type.name,
                    value: type.id,
                    isClass: type.is_class,
                    type: type,
                };
            } else {
                return null;
            }
        })
        .filter(o => !!o);

    if (defaultAll && (!value || value.length === 0)) {
        // Default to all being checked
        value = eventTypeOptions.map(opt => opt.value);
    }

    return (
        <CheckboxList
            id={id}
            value={value}
            onChange={value => {
                if (defaultAll && value.length === eventTypeOptions.length) {
                    // All are checked, make it empty
                    onChange([]);
                } else {
                    onChange(value);
                }
            }}
            options={eventTypeOptions}
            renderLabel={renderLabel}
        />
    );
};

export default EventTypeCheckboxes;
